import React from 'react'

export default ({ size = 1, isLoading = true, children = null }) => (
  <React.Fragment>
    {isLoading ? <i className={`fa fa-spinner fa-${size}x fa-pulse fa-fw`} /> : children}
  </React.Fragment>
)
